module.exports = __webpack_public_path__ + "img/quividi.38e41743.png";